import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import KingCountyContractors from "@/pages/KingCountyContractors";

export const Route = createFileRoute("/king-county-contractors")({
  component: KingCountyContractors,
  head: () =>
    pageHead({
      title: "Contractor Web Design and Local SEO | King County & Western Washington | jaik",
      description: "Contractor website design and local SEO across King County and western Washington. City pages for Seattle, Bellevue, Tacoma, Everett, Bellingham, Vancouver and more.",
      path: "/king-county-contractors",
    }),
});
